import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { Chip } from '@mui/material';
import PropTypes from 'prop-types';

const VARIANTS = {
  open: { label: 'Scanner connected', color: 'success', Icon: CheckCircleIcon },
  connecting: { label: 'Connecting to scanner…', color: 'warning', Icon: HourglassEmptyIcon },
  closed: { label: 'Scanner disconnected', color: 'error', Icon: ErrorIcon },
};

const ConnectionStatusPill = ({ status }) => {
  const { label, color, Icon } = VARIANTS[status] ?? VARIANTS.connecting;
  return <Chip icon={<Icon />} label={label} color={color} size='small' variant='outlined' />;
};

ConnectionStatusPill.propTypes = {
  status: PropTypes.oneOf(['open', 'connecting', 'closed']).isRequired,
};

export default ConnectionStatusPill;
